module.exports = __webpack_public_path__ + "img/icon_phone@2x.9a2c1298.png";